import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-10.000000, -5.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M29.0739 74H23.5341L39.5568 30.3636H45.0114L61.0341 74H55.4943L42.4545 37.267H42.1136L29.0739 74ZM31.1193 56.9545H53.4489V61.642H31.1193V56.9545Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
